export default "__VITE_ASSET__92d0a072__"